import { Container, ContainerItem } from '../common/container/Container'
import { UserProps } from '../modules/users/container'
import { getAppContainer } from './app'
import { moduleURLs } from '../config/api'
import { CLINIC_API_KEY, CLINIC_SERVICE_KEY, CLINICS_MODULE } from '../modules/clinics'
import { ClinicService } from '../modules/clinics/services/ClinicService'
import { ClinicApi } from '../modules/clinics/api/ClinicApi'

let container: Container

function init(p: UserProps) {
  const items = new Map<symbol, ContainerItem>()

  items.set(CLINIC_API_KEY, new ContainerItem({ instance: new ClinicApi() }))
  items.set(
    CLINIC_SERVICE_KEY,
    new ContainerItem({
      instance: new ClinicService({ apiKey: CLINIC_API_KEY }),
    })
  )

  container = new Container(items, p.parentContainer, p.config)
}

export function getClinicContainer(): Container {
  if (!container) {
    init({
      parentContainer: getAppContainer(),
      config: {
        moduleFullUrl: moduleURLs[CLINICS_MODULE],
      },
    })
  }

  return container
}
